import { ChevronLeft } from "lucide-react";

export default function EntryRequirement({ data }) {
  const countryCodeMap = {
    India: "in",
    Canada: "ca",
    "United States of America": "us",
    "Sri Lanka": "lk",
  };
  const stripHtml = (html) => {
    if (!html) return "";
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };
  return (
    <div className="space-y-6 font-inter">
      {/* ================= Academic Requirement ================= */}
      <div className="bg-white border border-gray-200 rounded-2xl p-6 relative overflow-hidden">
        <h3 className="text-[#572575] flex items-center gap-2 font-bold text-lg mb-5">
          <img src="/courseDetails/CO.png" alt="CO" className="h-5 w-5" />{" "}
          Academic Requirement
        </h3>

        <table className="w-full text-[13px]">
          <thead className="bg-purple-50 text-purple-700">
            <tr>
              <th className="p-3 text-left font-semibold">Intakes</th>
              <th className="p-3 text-center font-semibold">Study Level</th>
              <th className="p-3 text-center font-semibold">Percentage</th>
              <th className="p-3 text-center font-semibold">
                Backlog Acceptances
              </th>
            </tr>
          </thead>

          <tbody>
            {data.entryRequirement.academic_details?.map((item, i) => {
              const code = countryCodeMap[item.country_name] || "in";

              return (
                <tr key={i} className="border-t">
                  {/* Country */}
                  <td className="p-3 text-left">
                    <div className="flex items-center gap-2">
                      <img
                        src={`https://flagcdn.com/w20/${code}.png`}
                        alt={item.country_name}
                        className="w-5 h-auto rounded-sm"
                      />
                      <span className="font-semibold text-black">
                        {item.country_name}
                      </span>
                    </div>
                  </td>

                  {/* Study Level */}
                  <td className="p-3 text-center font-semibold text-black">
                    {item.course_level}
                  </td>

                  {/* Percentage */}
                  <td className="p-3 text-center">
                    <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-[11px] font-semibold">
                      {item.percentage || "—"}%
                    </span>
                  </td>

                  {/* Backlog */}
                  <td className="p-3 text-center">
                    <span className="bg-red-100 text-red-600 px-3 py-1 rounded-full text-[11px] font-semibold">
                      No
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        <div className="absolute -right-10 -top-10 w-32 h-32 bg-purple-100 rounded-full opacity-40" />
      </div>

      {/* ================= Mandatory Subjects ================= */}
      <div className="bg-white border border-gray-200 rounded-2xl p-6">
        <h3 className="text-[#572575] flex items-center gap-2 font-bold text-lg mb-5">
          <img src="/courseDetails/book.png" alt="book" className="h-5 w-5" />{" "}
          Mandatory Subjects
        </h3>

        <table className="w-full text-[13px]">
          <thead className="bg-orange-50 text-orange-600">
            <tr>
              <th className="p-3 text-left font-semibold">Subject</th>
              <th className="p-3 text-center font-semibold">Percentage</th>
              <th className="p-3 text-center font-semibold">Grade</th>
            </tr>
          </thead>

          <tbody>
            {data.entryRequirement.mandatory_subjects?.map((item, i) => (
              <tr key={i} className="border-t">
                {/* Subject */}
                <td className="p-3 font-semibold text-black">
                  {item.subject_name}
                </td>

                {/* Percentage */}
                <td className="p-3 text-center font-semibold text-black">
                  {item.percentage && item.percentage !== "0.00"
                    ? `${item.percentage}%`
                    : "--"}
                </td>

                {/* Grade */}
                <td className="p-3 text-center font-semibold text-black">
                  {item.grade || "--"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ================= English Proficiency Requirement ================= */}
      <div className="bg-white border border-gray-200 rounded-2xl p-6">
        <h3 className="text-[#572575] flex items-center gap-2 font-bold text-lg mb-5">
          <img src="/courseDetails/notepad.png" alt="CO" className="h-5 w-5" />
          English Proficiency Requirement
        </h3>

        <table className="w-full text-[13px]">
          <thead className="bg-purple-50 text-purple-700">
            <tr>
              <th className="p-3 text-left font-semibold">Subject</th>
              <th className="p-3 text-center font-semibold">Listening</th>
              <th className="p-3 text-center font-semibold">Reading</th>
              <th className="p-3 text-center font-semibold">Writing</th>
              <th className="p-3 text-center font-semibold">Speaking</th>
              <th className="p-3 text-center font-semibold">Overall</th>
            </tr>
          </thead>

          <tbody>
            {data.entryRequirement?.english_proficiency_requirements?.length >
            0 ? (
              data.entryRequirement.english_proficiency_requirements.map(
                (item) => (
                  <tr key={item.english_proficiency_id} className="border-t">
                    {/* Test Type */}
                    <td className="p-3 font-semibold text-black">
                      {item.test_type}
                    </td>

                    {/* Listening */}
                    <td className="p-3 text-center">
                      {item.listening !== "0.0" ? item.listening : "—"}
                    </td>

                    {/* Reading */}
                    <td className="p-3 text-center">
                      {item.reading !== "0.0" ? item.reading : "—"}
                    </td>

                    {/* Writing */}
                    <td className="p-3 text-center">
                      {item.writing !== "0.0" ? item.writing : "—"}
                    </td>

                    {/* Speaking */}
                    <td className="p-3 text-center">
                      {item.speaking !== "0.0" ? item.speaking : "—"}
                    </td>

                    {/* Overall */}
                    <td className="p-3 text-center font-semibold text-black">
                      {item.overall || "—"}
                    </td>
                  </tr>
                )
              )
            ) : (
              <tr>
                <td colSpan={6} className="p-4 text-center text-gray-500">
                  No English Proficiency Requirements Available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* ================= Special Entry Requirement ================= */}
      <div className="bg-white border border-gray-200 rounded-2xl p-6 relative overflow-hidden">
        <h3 className="text-[#572575] flex items-center gap-2 font-bold text-lg mb-5">
          <img src="/courseDetails/SER.png" alt="SER" className="h-5 w-5" />{" "}
          Special Entry Requirement
        </h3>

        <p className="text-sm font-semibold text-black leading-relaxed ">
          {stripHtml(data.entryRequirement.special_entry_requirement)}
        </p>

        <div className="absolute right-[-40px] bottom-[-40px] w-40 h-40 bg-purple-100 rounded-full opacity-40" />
      </div>
    </div>
  );
}
